/**
 * @module components\TopHeader
 */
import core from '@/services/core';
import store from '@/store';
import Vue from 'vue';
import Component from 'vue-class-component';
import sToast from '@/services/sToast';

@Component
export default class TopHeader extends Vue {
  balance=this.superInitData.payload2.length>0?this.superInitData.payload2[0].balance:'';
  items= [
    { title: 'Team Spice', text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.', notificationStatus: 'new-notification' },
    { title: 'Team Spice', text: 'Lorem ipsum dolor sit amet', notificationStatus: 'old-notification' },
    { title: 'Team Spice', text: 'Lorem ipsum dolor sit amet', notificationStatus: 'old-notification' },
  ];
  loading=false;
drawer=true;
get superInitData(){
  return store.getters.updateSuperInitDataGet;
  }

  logout() {
    let request={"token":store.getters.sessLoginDataGet.sessionId,"merchantClientId": this.clientDetails.clientId};
    core
      .post({
        data: request,
        url: 'sessLogout',
        method: 'post'
      })
    .then(response => {
      store.dispatch('updateIsLoginAc', false);
      store.dispatch('updateSuperInitDataAc', null);
      this.$router.replace({ name: "login" });
      setTimeout(()=>{
        window.location.reload();
      },500)
    })
    .catch(error => {
      store.dispatch('updateIsLoginAc', false);
      this.$router.replace({ name: "login" });
    });
  }
  setDrawerState(){
    this.drawer=!store.getters.userNavDataGet;
    store.dispatch('updateUserNavDataAc',this.drawer)
  }
  get clientDetails(){
    return store.getters.updateSuperInitDataGet?store.getters.updateSuperInitDataGet.payload2[0]:null
  }
  get staticData(){
    return store.getters.staticDataGet;
    }
  reloadSuperInit(){
    let module= this.staticData.payload.ccSearchModule.concat(this.staticData.payload.cdSearchModule);
    let request={
        token: store.getters.sessLoginDataGet.sessionId,
        requestModule:store.getters.sessLoginDataGet.requestModule,
        requestType: "WEB",
        merchantClientId: store.getters.sessLoginDataGet.clientId,
        requestFor:module.length==1?'DASH':'INFO',
        aggId:'',
        finoClientId:''
};
      core
        .post({
          data: request,
          url: 'superinitWeb',
          method: 'post'
        })
      .then(response => {
        this.loading = false;
        this.balance=response.payload2[0].balance;
        store.dispatch('updateSuperInitDataAc', response);
      })
      .catch(error => {
        this.loading = false;
      });
}
  
updateBalance(){
  let module= this.staticData.payload.ccSearchModule.concat(this.staticData.payload.cdSearchModule);
  let request={
      token: store.getters.sessLoginDataGet.sessionId,
      requestModule:store.getters.sessLoginDataGet.requestModule,
      requestType: "WEB",
      merchantClientId: store.getters.sessLoginDataGet.clientId,
      requestFor:module.length==1?'DASH':'INFO',
      aggId:'',
      finoClientId:''
};
    core
      .post({
        data: request,
        url: 'superinitWeb',
        method: 'post'
      })
    .then(response => {
      this.loading = false;

     this.balance=response.payload2[0].balance;
    })
    .catch(error => {
      this.loading = false;
    });
}
}
